exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table {\n  width: 100%;\n  font-size: 14px;\n  font-weight: bold; }\n  table thead th {\n    color: #0275d8;\n    padding: 7px 10px; }\n  table tbody tr:hover td {\n    background: #eaeaea; }\n  table tbody tr.indicator {\n    width: 100%; }\n    table tbody tr.indicator td {\n      background: #eaeaea;\n      color: transparent; }\n  table tbody tr.spacer {\n    height: 10px;\n    background: transparent; }\n  table tbody tr td {\n    color: #333;\n    padding: 7px 10px;\n    background: white; }\n    table tbody tr td:first-child {\n      border-top-left-radius: 10px; }\n    table tbody tr td:last-child {\n      border-top-right-radius: 10px; }\n    table tbody tr td:first-child {\n      border-bottom-left-radius: 10px; }\n    table tbody tr td:last-child {\n      border-bottom-right-radius: 10px; }\n\n.navigation .pagination li.page-item {\n  font-size: 12px; }\n  .navigation .pagination li.page-item a {\n    color: #333; }\n    .navigation .pagination li.page-item a.active {\n      color: white;\n      background: #0275d8; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/app/shared/data-table/data.table.component.scss
// module id = ../../../../../src/app/shared/data-table/data.table.component.scss
// module chunks = 1